<template>
    <span
        ref="content"
        :class="{'cell-truncate': truncate}"
        :style="truncate ? {display: 'block', width: cellWidth} : {}">
        <!-- closing tag in the same line as the text is required to avoid whitespace after component -->
        {{ text }}<b-tooltip
            v-if="isTooltipEnabled"
            :animation="false"
            :delay="tooltipDelayConfig"
            placement="left"
            :target="() => $refs.content"
            triggers="hover">
            <span :class="small ? 'small' : ''" v-html="tooltip"></span>
        </b-tooltip></span>
</template>

<script>
    import {BTooltip} from 'bootstrap-vue/src';
    import '@desktop/scss/components/text-with-tooltip.scss';

    export default {
        components: {
            BTooltip,
        },
        props: {
            delay: {
                type: Number,
                default: 0,
            },
            small: {
                type: Boolean,
                default: false,
            },
            text: {
                type: String,
                required: true,
            },
            tooltip: {
                type: String,
                default: '',
            },
            // For single line content: Only show the tooltip if the text is being truncated.
            truncate: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                cellWidth: 'auto',
                isOverflowing: false,
            };
        },
        computed: {
            isTooltipEnabled() {
                if (this.tooltip === '') {
                    return false;
                }
                return this.truncate ? this.isOverflowing : true;
            },
            tooltipDelayConfig() {
                return {show: this.delay, hide: 0};
            },
        },
        watch: {
            text() {
                this.$nextTick(this.updateOverflowState());
            },
        },
        mounted() {
            if (!this.truncate) {
                return;
            }

            this.updateOverflowState();

            if (typeof ResizeObserver !== 'undefined') {
                this.resizeObserver = new ResizeObserver(this.updateOverflowState());
                this.resizeObserver.observe(this.$el);
            }
        },
        beforeDestroy() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
            }
        },
        methods: {
            updateOverflowState() {
                const td = this.$el.closest('td');
                const width = td ? td.clientWidth : null;

                if (width) {
                    // Constrain the span to the real cell width so scrollWidth reflects overflow.
                    this.cellWidth = width + 'px';
                }

                this.$nextTick(() => {
                    const element = this.$refs.content;
                    if (!element) {
                        return;
                    }
                    this.isOverflowing = element.scrollWidth > element.clientWidth;
                });
            },
        },
    }
</script>
